'use client';

import { useEffect, useState } from 'react';
import type { DEVICE_TYPE } from '../constants';
import { checkDeviceType, checkDeviceTypeBrowser } from '../utils';

export const useDeviceType = (): DEVICE_TYPE => {
    const [deviceType, setDeviceType] = useState<DEVICE_TYPE>(checkDeviceType);

    useEffect(() => {
        const changeDeviceType = () => {
            setDeviceType(checkDeviceTypeBrowser());
        };
        window.addEventListener('resize', changeDeviceType);

        return () => {
            window.removeEventListener('resize', changeDeviceType);
        };
    }, []);

    return deviceType;
};
